export default __webpack_public_path__ + "static/media/cr.fcd130ef.svg";